import React from 'react';
import styled from 'styled-components';
import { media } from 'utils/style';
import XPOLogo from 'assets/xpo_icons/xpo-byexpressnow-logo.png';

const LandingHeader = styled.header`
  position: fixed;
  top: 0;
  width: 50%;
  color: #fff;
  padding: 50px;
  text-align: left;
  z-index: 99;
  ${media.lessThan('small')`
    width: 100%;
    background-color: #000;
  `};
  ${media.lessThan('extraSmall')`
    padding: 30px;
  `};
`;

const XpressNowLogo = styled.div`
  display: block;
  width: 300px;
  height: 58px;
  background-image: url(${XPOLogo});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  ${media.lessThan('extraSmall')`
    width: 200px;
    height: 40px;
  `};
`;


export const Header = () => {
    return (
      <LandingHeader>
        <XpressNowLogo />
      </LandingHeader>
    );
  };